const _hashRandom = () => parseInt(Math.random() * 1000);
const _hash = () => `${_hashRandom()}${_hashRandom()}${_hashRandom()}${_hashRandom()}${_hashRandom()}`;

export default class Utils {
  /**
   * @param {Object} Vue
   * @param {Object} Vue.prototype
   * @param {import('./Portal').default} Vue.prototype.$portal
   * @param {import('./Company').default} Vue.prototype.$company
   * @param {import('./User').default} Vue.prototype.$user
   */
  constructor(Vue) {
    this.portal = Vue.prototype.$portal;
    this.company = Vue.prototype.$company;
    this.user = Vue.prototype.$user;

    Vue.prototype.$user.utils = this;
    Vue.prototype.$company.utils = this;
    Vue.prototype.$chat.utils = this;

    this.log = false;

    this.validator = {
      isEmail: arg => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(arg),

      validateMultipleEmails: (emails = '') => {
        const separatedEmails = emails.split(';');
        return !separatedEmails.some(email => !this.validator.isEmail(email));
      },

      isCnpjCpf: arg => {
        if (!arg) return false;
        if (arg.length === 11) return this.validator.isCpf(arg);
        if (arg.length === 14) return this.validator.isCnpj(arg);
        return false;
      },

      isCnpj: val => {
        // Captura os primeiros 12 números do CNPJ
        const firstNumbers = val.substr(0, 12);
        // Faz o primeiro cálculo
        const calc1 = this.validator._calcDigitsPositionsCnpj(firstNumbers, 5);
        // O segundo cálculo é a mesma coisa do primeiro, porém, começa na posição 6
        const calc2 = this.validator._calcDigitsPositionsCnpj(calc1, 6);
        // Concatena o segundo dígito ao CNPJ
        const cnpj = calc2;
        // Verifica se o CNPJ gerado é idêntico ao enviado
        if (cnpj === val) return true;
        return false;
      },

      isCpf: val => {
        // Captura os 9 primeiros dígitos do CPF
        const digits = val.substr(0, 9);
        // Faz o cálculo dos 9 primeiros dígitos do CPF para obter o primeiro dígito
        const calc1 = this.validator._calcDigitsPositionsCpf(digits);
        // Faz o cálculo dos 10 dígitos do CPF para obter o último dígito
        const cpf = this.validator._calcDigitsPositionsCpf(calc1, 11);
        // Verifica se o CPF gerado é idêntico ao CPF enviado
        if (cpf === val) return true;
        return false;
      },

      _calcDigitsPositionsCnpj: (digits, positions = 10, sumDigits = 0) => {
        digits = digits.toString();

        for (let i = 0; i < digits.length; i++) {
          sumDigits += (digits[i] * positions);
          positions--;
          if (positions < 2)
            positions = 9;
        }
        sumDigits %= 11;
        if (sumDigits < 2)
          sumDigits = 0;
        else sumDigits = 11 - sumDigits;

        const cnpj = digits + sumDigits;
        return cnpj;
      },

      _calcDigitsPositionsCpf: (digits, positions = 10, sumDigits = 0) => {
        digits = digits.toString();
        let equalDigits = true;

        for (let i = 0; i < digits.length; i++) {
          if (digits[i] != digits[i - 1] && i != 0)
            equalDigits = false;

          sumDigits += (digits[i] * positions);
          positions--;
        }
        sumDigits %= 11;
        if (sumDigits < 2)
          sumDigits = 0;
        else sumDigits = 11 - sumDigits;

        if (equalDigits) return '0';
        const cpf = digits + sumDigits;
        return cpf;
      },

    };

    this.getScript = script => new Promise((resolve, reject) => {
      if (_.has(brain, 'dev.is') && brain.dev.is === 'DEV') {
        this.router({
          event: 'local/script',
          script,
        })
          .then(res => resolve(res))
          .catch(err => reject(err));
      } else {
        $.get(this.portal.url.script + script)
          .then(res => resolve(res))
          .fail(err => reject(err));
      }
    });

    this.getCompany = domain => new Promise((resolve, reject) => {
      if (this.company.locationJson.includes('localhost')) {
        $.get(`${this.portal.url.endPoint.app}/v1/integration/config/get?id=local`)
          .then(res => resolve(res.data))
          .catch(err => reject(err));
      } else {
        $.get({
          url: `${this.portal.url.cache.company.json}${domain}.json`,
          cache: false,
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }
    });

    this.simpleAjax = ({
      method = 'GET',
      url,
      headers = {},
      data,
    }) => $.ajax({
      type: method,
      url,
      headers: {
        'Content-Type': 'application/json',
        code: _.get(this.user, 'token') || undefined,
        'origin-url': window.location.origin || undefined,
        ...headers,
      },
      data: (data) ? this.format.objectToString(data) : undefined,
    });

    this.berserkerRequest = ({
      url,
      data,
    }) => new Promise((resolve, reject) => {
      $.ajax({
        method: 'POST',
        url,
        data: {
          ...data,
          userorigin: brain.company.json.id,
          username: brain.user.json.nick,
          useremail: brain.user.json.email,
          userphone: brain.user.json.phone,
        },
      })
        .always((res, textStatus, xhr) => {
          const status = _.get(res, 'status') || _.get(xhr, 'status');

          if (status === 200 || status === 201) return resolve({ data: res, status });

          return reject({ responseJSON: (_.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res), status });
        });
    });

    /**
     * @param {Object} $0
     * @param {string} [$0.method]
     * @param {string} $0.uri
     * @param {string} $0.microservice
     * @param {{ [key: string]: string }} [$0.headers]
     * @param {any} [$0.data]
     */
    this.ajaxMicroservice = ({
      method,
      uri,
      microservice,
      headers = undefined,
      data = undefined,
    }) => new Promise((resolve, reject) => this.simpleAjax({
      url: `${this.portal.url.endPoint[microservice]}${uri}`,
      method,
      headers,
      data,
    })
      .then(resolve)
      .fail(reject));

    this.requestErrorSwalMessage = (err = {}) => {
      const message = _.get(err, 'responseJSON.message') || _.get(err, 'responseJSON.error.message');
      const error = JSON.stringify(_.get(err, 'responseJSON.error'));
      const code = _.get(err, 'responseJSON.error.code');
      return `
        <div style="margin: 10px;">
          <small class="text-muted">
            StatusCode: ${err.status} / Erro: ${code ? `#${code} -` : ''} ${message || error || ''}
          </small>
        </div>
      `;
    };

    this.remoteSqlCore = {
      executeSqlBypass: (type, url, headers, callback) => {
        if (headers && headers.replace) headers.replace = decodeURI(headers.replace);
        else headers.replace = undefined;

        try {
          if (typeof headers.replace === 'string') headers.replace = JSON.parse(headers.replace);
        } catch (error) { }

        this.remoteSqlCore.executeSql({
          sql: headers.sqlId,
          connector: headers.connectorId,
          replace: headers.replace,
        })
          .then(res => {
            callback(res);
          })
          .catch(err => {
            callback(err);
          });
      },

      executeSql: ({
        sql,
        connector,
        replace = undefined,
        unique = false,
        requestSizeLimit = undefined,
        timeout = undefined,
        method = 'GET',
      }) => {
        if (requestSizeLimit) {
          return this.remoteSqlCore.executeSqlRecursive({
            sql,
            connector,
            replace,
            unique,
            requestSizeLimit,
          });
        }

        const enableBatch = _.get(this.company.json, 'enableBatch') || false;
        return new Promise((resolve, reject) => {
          if (!sql || !connector) return resolve({ status: 200, rows: [] });

          let data = '';
          let url = `${this.portal.url.endPoint.remoteSql}/v1/session/app/${this.company.json.id}/sql/${encodeURIComponent(sql)}?connector=${connector}`;

          if (replace) {
            if (method === 'GET') url += `&replace=${encodeURIComponent(JSON.stringify(replace))}`;
            else if (method === 'POST') data = JSON.stringify({ replace });
          }

          if (unique) url += `&unique=${unique}`;

          $.ajax({
            method,
            timeout,
            headers: {
              code: this.user.token,
              'Content-Type': 'application/json',
              'async-batch': enableBatch,
            },
            url,
            data,
          })
            .then((res, textStatus, xhr) => {
              const status = _.get(res, 'status') || _.get(xhr, 'status');
              if (status === 201) return this.remoteSqlCore.checkBatchJob(res.jobId);
              return res;
            })
            .then(resolve)
            .fail(err => {
              if (err.status === 401) return brain.sessionError(brain.router.currentRoute.fullPath);
              reject(err);
            });
        });
      },

      executeSqlRecursive: ({
        sql,
        connector,
        replace = [],
        unique,
        requestSizeLimit = 100,
        _rows = [],
        _page = 1,
        _indexInit = 1,
        _indexEnd = 100,
        resolve,
        reject,
      }) => new Promise((pResolve, pReject) => {
        if (!resolve) resolve = pResolve;
        if (!reject) reject = pReject;

        if (!sql || !connector) return resolve({ status: 200, rows: [] });

        if (_indexInit === 1) _indexEnd = requestSizeLimit;
        if (!Array.isArray(replace)) replace = [];

        this.remoteSqlCore.overwriteReplace({ replace, from: ':indexInit:', to: _indexInit });
        this.remoteSqlCore.overwriteReplace({ replace, from: ':indexEnd:', to: _indexEnd });
        this.remoteSqlCore.overwriteReplace({ replace, from: ':pageLimit:', to: requestSizeLimit });
        this.remoteSqlCore.overwriteReplace({ replace, from: ':page:', to: _page });

        this.remoteSqlCore.executeSql({
          sql,
          connector,
          replace,
          unique,
        })
          .then(res => {
            if (!res || _.get(res, 'status') === 500) return reject(res);

            let newRows = [..._rows];

            if (Array.isArray(res.rows) && res.rows.length === 0)
              return resolve({ status: 200, rows: _rows });

            newRows = newRows.concat(res.rows);

            return this.remoteSqlCore.executeSqlRecursive({
              sql,
              connector,
              replace,
              unique,
              requestSizeLimit,
              _rows: newRows,
              _indexInit: _indexEnd + 1,
              _page: _page + 1,
              _indexEnd: _indexEnd + requestSizeLimit,
              resolve,
              reject,
            });
          })
          .catch(err => reject(err));
      }),

      overwriteReplace({ replace, from, to } = {}) {
        if (!Array.isArray(replace)) return;

        const existent = replace.find(i => i.from === from);
        if (existent)
          existent.to = to;
        else replace.push({ from, to });

        return replace;
      },

      checkBatchJob: jobId => {
        const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

        const request = () => (
          new Promise((resolve, reject) => {
            $.ajax({
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'cache-control': 'no-cache',
                'max-wait-time': 300000,
              },
              url: `${this.portal.url.endPoint.remoteSql}/v1/general/app/${this.company.json.id}/batch/${jobId}`,
            })
              .then(resolve)
              .fail(err => reject(err));
          })
        );

        const loopRequest = async () => {
          try {
            return await request();
          } catch (err) {
            if (err.status === 404) {
              await wait(1000);
              return loopRequest();
            }

            throw err;
          }
        };

        return loopRequest();
      },
    };

    this.faccionistaCore = {
      simpleAccess: ({
        method,
        url,
        headers,
        data,
      }) => this.simpleAjax({
        url: `${this.portal.url.endPoint.faccionista}${url}`,
        method,
        headers,
        data,
      }),

      uploadXml: ({ file }) => new Promise((resolve, reject) => {
        console.log(this.company.json.id);
        this.simpleAjax({
          method: 'POST',
          url: `/faccionista/v1/session/app/${this.company.json.id}/production-order/uploadXml`,
          data: file,
        })
          .then(res => {
            console.log(res);
          })
          // .then(() => resolve(data))
          .catch(err => {
            console.log('deu erro');
            console.log(err);
          });
      }),

    };

    this.accessCore = {
      simpleAccess: ({
        method,
        url,
        headers,
        data,
      }) => this.simpleAjax({
        url: `${this.portal.url.endPoint.access}${url}`,
        method,
        headers,
        data,
      }),

      getEntity: ({ entityCode } = {}) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          url: `/v1/session/app/${this.company.json.id}/entity/${entityCode}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            const status = _.get(err, 'status');

            if (status === 401) {
              brain.sessionError();
            } else if (status === 0 || status >= 500) {
              const data = _.get(err, 'responseJSON') || err;
              const params = { entityCode };
              brain.connectionError({ params, stack: { data, method: 'getEntity' } }, false);
            }

            return reject(err);
          });
      }),

      listEntityByUser: ({ fields = '', query = '', limit = '' } = {}) => new Promise((resolve, reject) => {
        const strFields = (Array.isArray(fields)) ? fields.join(';') : '';
        const queryString = `fields=${encodeURIComponent(strFields)}&query=${query}&limit=${limit}`;

        this.accessCore.simpleAccess({
          url: `/v1/session/app/${this.company.json.id}/entity/list?${queryString}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            const status = _.get(err, 'status');

            if (status === 401) {
              brain.sessionError();
            } else if (status === 0 || status >= 500) {
              const data = _.get(err, 'responseJSON') || err;
              const params = { fields, query, limit };
              brain.connectionError({ params, stack: { data, method: 'listEntityByUser' } }, false);
            }

            return reject(err);
          });
      }),

      listEntityByHost: email => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          url: `/v1/entity/listByHost?id=${this.company.json.id}&email=${email}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      giveEntityToAnotherUser: (email, entityCode) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/entity/giveToAnotherUser?id=${this.company.json.id}&email=${email}&entityCode=${entityCode}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      removeEntityByHost: (email, entityCode) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/entity/removeByHost?id=${this.company.json.id}&email=${email}&entityCode=${entityCode}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      entityAudit: () => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          url: `/v1/app/${this.company.json.id}/entity/audit`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      newCnpjByAutoValidate: cnpj => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/entity/${cnpj}/autoValidate`,
        })
          .always(res => {
            if (res && res.status === 201) return resolve();
            if (res && (res.status === 0 || res.status >= 500)) {
              const data = _.get(res, 'responseJSON') || res;
              brain.connectionError({ cnpj, stack: { data, method: 'newCnpjByAutoValidate' } });
              return reject(true);
            }
            if (res && (res.status === 401)) return brain.sessionError();
            return reject();
          });
      }),

      newCnpjByQuestion: (cnpj, answer) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/entity/${cnpj}/question`,
          data: JSON.stringify({ answer }),
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 201) return resolve();
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ cnpj, answer, stack: { status, data, method: 'newCnpjByQuestion' } });
              return reject(true);
            }
            if (status === 401) return brain.sessionError();
            return reject();
          });
      }),

      newCnpjPendingApproval: (cnpj, formData = {}) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/entity/${cnpj}/approval`,
          data: JSON.stringify({
            description: formData.description,
            tag1: formData.tag1,
            tag2: formData.tag2,
            options: formData.customOptions,
            term: formData.term,
          }),
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 201) return resolve();
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ cnpj, formData, stack: { status, data, method: 'newCnpjPendingApproval' } });
              return reject(true);
            }
            if (status === 401) return brain.sessionError();
            return reject();
          });
      }),

      loadEntityPendingApproval: () => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          url: `/v1/session/app/${this.user.json.id}/entity/pendingApproval`,
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 200) return resolve(res);
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ stack: { status, data, method: 'loadEntityPendingApproval' } });
              return reject(res);
            }
            if (status === 401) return brain.sessionError();
            return reject();
          });
      }),

      getMFAPossibilitiesByEntity: entityCode => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          url: `/v1/session/app/${this.user.json.id}/entity/${entityCode}/mfa`,
        })
          .always((res, statusText, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (_.get(res, 'possibilities')) return resolve(res);
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ entityCode, stack: { status, data, method: 'getMFAPossibilitiesByEntity' } });
              return reject(true);
            }
            if (status === 401) return brain.sessionError();
            return reject();
          });
      }),

      sendMFA: (entityCode, option) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/entity/${entityCode}/mfa?option=${encodeURIComponent(option)}`,
        })
          .always((res, statusText, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 201) return resolve();
            if (status === 401) return brain.sessionError();
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ entityCode, option, stack: { status, data, method: 'sendMFA' } });
            }

            return reject(res);
          });
      }),

      authenticateMFA: mfa => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/mfa/authenticate`,
          data: JSON.stringify({ mfa }),
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 200) return resolve();
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ mfa, stack: { status, data, method: 'authenticateMFA' } });
              return reject(true);
            }
            if (status === 401) return brain.sessionError();
            return reject();
          });
      }),

      removeEntity: entity => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'DELETE',
          url: `/v1/session/app/${this.user.json.id}/entity/${entity}`,
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 200) return resolve(res);
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ entity, stack: { status, data, method: 'removeEntity' } });
              return reject({ res, xhr });
            }
            if (status === 401) return brain.sessionError();
            return reject({ res, xhr });
          });
      }),

      updateEntity: ({
        code, description, tag1, tag2, externalId, dynamicFields, id,
      } = {}) => new Promise((resolve, reject) => {
        this.accessCore.simpleAccess({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/entity/${code}`,
          data: {
            code,
            description,
            tag1,
            tag2,
            externalId,
            dynamicFields,
            id,
          },
          headers: {
            'Content-Type': 'application/json',
            code: this.user.token,
          },
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 200) return resolve(res);
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ entity, stack: { status, data, method: 'updateEntity' } });
              return reject({ res, xhr });
            }
            if (status === 401) return brain.sessionError();
            return reject({ res, xhr });
          });
      }),
    };

    this.authCore = {
      simpleAuth: ({
        method,
        url,
        headers,
        data,
      }) => this.simpleAjax({
        url: `${this.portal.url.endPoint.auth}${url}`,
        method,
        headers,
        data,
      }),

      createGuest: email => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/user/createGuest?id=${this.company.json.id}&email=${email}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      listGuest: () => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          url: `/v1/user/listGuest?id=${this.company.json.id}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      modifyGroupByHost: (email, group, type) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/user/modifyGroupByHost?id=${this.company.json.id}&email=${email}&group=${encodeURIComponent(group)}&type=${type}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      changeEnableByHost: (email, enable) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/user/changeEnableByHost?id=${this.company.json.id}&email=${email}&enable=${enable}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      removeGuestByHost: email => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/user/removeGuestByHost?id=${this.company.json.id}&email=${email}`,
        })
          .then(res => resolve(res))
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      userExists: email => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          url: `/v1/user/exists?id=${this.company.json.id}&email=${email}`,
        })
          .then(res => {
            if (!res || !res.status || !res.data || res.status !== 'success') return reject(res);

            return resolve(res);
          })
          .fail(err => {
            if (err && (err.status === 401)) return brain.sessionError();
            return reject(err);
          });
      }),

      login: (email, password) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${this.company.json.id}/login`,
          data: JSON.stringify({
            email,
            password,
          }),
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      sessionValidate: code => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          url: `/v1/general/app/${this.company.json.id}/session/${code}/validate`,
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      getUserData: email => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          url: `/v1/session/app/${this.company.json.id}/user/${email}`,
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      createUser: (email, id, sendEmail = true) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${id || this.company.json.id}/user/${email}`,
          headers: {
            'send-email': sendEmail,
          },
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      getAdfsProviderAuthentication: () => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'GET',
          url: `/v1/app/${this.company.json.id}/federation/adfs`,
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      loginByFederationCode: code => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'GET',
          url: `/v1/app/${this.company.json.id}/federation/login/code/${code}`,
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      completeUserRegister: ({
        hash,
        email,
        nick,
        password,
        phone,
      } = {}) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${this.company.json.id}/user/${email}`,
          headers: {
            'created-hash': hash,
          },
          data: {
            nick,
            password,
            phone,
          },
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      updateEntitySelected: () => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/session/app/${this.company.json.id}/user/${this.user.json.email}/entity`,
          data: {
            entities: JSON.parse(JSON.stringify(this.user.selectedEntity)),
          },
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      validateUserHash: (email, hashType, hash) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${this.company.json.id}/user/${email}/${hashType}/${hash}/validate`,
        })
          .then(res => resolve(res))
          .fail(err => reject(err));
      }),

      updateUser: body => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/session/app/${this.company.json.id}/user/update`,
          data: JSON.stringify(body),
        })
          .then(resolve)
          .fail(err => {
            if (err.status === 401) return brain.sessionError();
            reject(err);
          });
      }),

      updateProfile: (nick, phone) => this.authCore.updateUser({
        nick, phone,
      }),

      updateNotifications: notifications => this.authCore.updateUser({
        notifications,
      }),

      updatePassword: (oldPassword, password) => this.authCore.updateUser({ oldPassword, password }),

      requestNewPassword: email => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${this.company.json.id}/user/${email}/password`,
        })
          .then(resolve)
          .fail(reject);
      }),

      updatePasswordWithHash: (email, hash, password) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${this.company.json.id}/user/${email}/password`,
          headers: {
            'password-hash': hash,
          },
          data: {
            password,
          },
        })
          .then(resolve)
          .fail(reject);
      }),

      authenticateUserDirectHash: hash => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/general/app/${this.company.json.id}/user/directHash/${hash}`,
        })
          .then(resolve)
          .fail(err => {
            const status = _.get(err, 'status');

            // if (status === 401) return brain.sessionError();
            if (status === 0 || status >= 500) {
              const error = _.get(err, 'responseJSON') || err;
              brain.connectionError({ hash, stack: { status, error, method: 'authenticateUserDirectHash' } });
              return reject({ status, error });
            }
            return reject({ status, error: err });
          });
      }),

      generateUserDirectHash: ({
        email,
        title,
        script,
        json,
        expires,
      } = {}) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/session/app/${this.company.json.id}/user/${email}/directHash`,
          data: {
            title,
            script,
            json,
            expires,
          },
        })
          .then(resolve)
          .fail(err => {
            const status = _.get(err, 'status');

            if (status === 401) return brain.sessionError();
            if (status === 0 || status >= 500) {
              const error = _.get(err, 'responseJSON') || err;
              brain.connectionError({
                title,
                script,
                json,
                expires,
                stack: { status, error, method: 'generateUserDirectHash' },
              });
              return reject({ status, error });
            }
            return reject({ status, error: err });
          });
      }),

      generateUserByPhoneDirectHash: ({
        phone,
        title,
        script,
        json,
        expires,
      } = {}) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/app/${this.company.json.id}/user/phone/${phone}/directHash`,
          data: {
            title,
            script,
            json,
            expires,
          },
        })
          .then(resolve)
          .fail(err => {
            const status = _.get(err, 'status');

            if (status === 401) return brain.sessionError();
            if (status === 0 || status >= 500) {
              const error = _.get(err, 'responseJSON') || err;
              brain.connectionError({
                title,
                script,
                json,
                expires,
                stack: { status, error, method: 'generateUserByPhoneDirectHash' },
              });
              return reject({ status, error });
            }
            return reject({ status, error: err });
          });
      }),

      isEmail: email => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email),

      getEmailDomain: email => (this.authCore.isEmail(email) ? email.toLowerCase().split('@').pop() : ''),

      getMFAPossibilities: ({
        entityCode, remoteSql, connector,
      }) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          url: `/v1/session/app/${this.user.json.id}/entity/${entityCode}/mfa`,
          headers: {
            remotesql: remoteSql,
            connector,
          },
        })
          .always((res, statusText, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (_.get(res, 'possibilities')) return resolve(res);
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ entityCode, stack: { status, data, method: 'getMFAPossibilities' } });
              return reject(true);
            }
            if (status === 401) return brain.sessionError(res);
            return reject();
          });
      }),

      sendMFA: ({
        entityCode, option, remoteSql, connector,
      }) => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/entity/${entityCode}/mfa?option=${encodeURIComponent(option)}`,
          headers: {
            remotesql: remoteSql,
            connector,
          },
        })
          .always((res, statusText, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 201) return resolve();
            if (status === 401) return brain.sessionError(res);
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ entityCode, option, stack: { status, data, method: 'sendMFA' } });
            }

            return reject(res);
          });
      }),

      authenticateMFA: mfa => new Promise((resolve, reject) => {
        this.authCore.simpleAuth({
          method: 'POST',
          url: `/v1/session/app/${this.user.json.id}/mfa/authenticate`,
          data: JSON.stringify({ mfa }),
        })
          .always((res, textStatus, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 200) return resolve();
            if (status === 0 || status >= 500) {
              const data = _.get(res, 'responseJSON') || _.get(xhr, 'responseJSON') || res;
              brain.connectionError({ mfa, stack: { status, data, method: 'authenticateMFA' } });
              return reject(true);
            }
            if (status === 401) return brain.sessionError(res);
            return reject();
          });
      }),

    };

    this.fileCore = {
      simpleFile: ({
        method,
        url,
        headers,
        data,
      }) => this.simpleAjax({
        url: `${this.portal.url.endPoint.file}${url}`,
        method,
        headers,
        data,
      }),

      getFile: (key, type = 'base64') => new Promise((resolve, reject) => {
        this.fileCore.simpleFile({
          url: `/v1/session/app/${this.company.json.id}/key/${encodeURIComponent(key)}?type=${type}`,
        })
          .then(res => resolve(res))
          .catch(err => reject(err));
      }),

      signedUploadFile: ({
        path,
        filename,
        filetype = 'application/octet-stream',
        storageType = 'app-storage',
        file,
        routeType = 'signed',
        useUniqueId = true,
      }) => new Promise((resolve, reject) => {
        const data = {};
        const routes = {
          signed: `/v1/session/app/${this.company.json.id}/signedUpload`,
          public: `/v1/public/app/${this.company.json.id}/upload`,
        };
        const url = routes[routeType] || routes.signed;

        this.fileCore.simpleFile({
          method: 'POST',
          url,
          headers: {
            path,
            filename,
            filetype,
            'storage-type': storageType,
            'use-unique-id': useUniqueId,
          },
        })
          .then(res => {
            if (!res || !res.key || !res.url) return reject({ status: 500, message: 'Não foi possível fazer upload do arquivo.' });

            data.key = res.key;
            data.link = res.link;

            return $.ajax({
              method: 'PUT',
              url: res.url,
              crossDomain: true,
              headers: {
                'Content-Type': filetype,
                'cache-control': 'no-cache',
              },
              processData: false,
              contentType: false,
              data: file,
            });
          })
          .then(() => resolve(data))
          .catch(err => {
            const status = _.get(err, 'status');

            if (status === 401) return brain.sessionError();
            if (status === 0 || status >= 500) {
              const error = _.get(err, 'responseJSON') || err;
              brain.connectionError({
                path,
                filename,
                storageType,
                stack: { status, error, method: 'signedUploadFile' },
              });
              return reject({ status, error });
            }
            return reject({ status, error: err });
          });
      }),

      uploadDigitalContent: ({
        path,
        module,
        moduleItem,
        file,
      }) => new Promise((resolve, reject) => {
        this.fileCore.simpleFile({
          url: `/v1/session/app/${this.company.json.id}/digital-content`,
          method: 'post',
          headers: {
            path,
            module,
            'module-item': moduleItem,
          },
          data: file,
        })
          .then(res => resolve(res))
          .catch(err => {
            const status = _.get(err, 'status');

            if (status === 401) return brain.sessionError();
            if (status === 0 || status >= 500) {
              const error = _.get(err, 'responseJSON', err);
              brain.connectionError({
                path,
                module,
                moduleItem,
                stack: { status, error, method: 'uploadDigitalContent' },
              });
              return reject({ status, error });
            }
            return reject({ status, error: err });
          });
      }),

      getDigitalContent: ({
        path,
        module,
        moduleItem,
      }) => new Promise((resolve, reject) => {
        this.fileCore.simpleFile({
          url: `/v1/session/app/${this.company.json.id}/digital-content`,
          method: 'get',
          headers: {
            path,
            module,
            'module-item': moduleItem,
          },
        })
          .then(res => resolve(res))
          .catch(err => {
            const status = _.get(err, 'status');

            if (status === 401) return brain.sessionError();

            return reject({ status, error: err });
          });
      }),

      removeAccents: text => {
        let r = text.toLowerCase();
        r = r.replace(new RegExp(/[àáâãäå]/g), 'a');
        r = r.replace(new RegExp(/æ/g), 'ae');
        r = r.replace(new RegExp(/ç/g), 'c');
        r = r.replace(new RegExp(/[èéêë]/g), 'e');
        r = r.replace(new RegExp(/[ìíîï]/g), 'i');
        r = r.replace(new RegExp(/ñ/g), 'n');
        r = r.replace(new RegExp(/[òóôõö]/g), 'o');
        r = r.replace(new RegExp(/œ/g), 'oe');
        r = r.replace(new RegExp(/[ùúûü]/g), 'u');
        r = r.replace(new RegExp(/[ýÿ]/g), 'y');
        return r;
      },
      validateUrl: url => {
        const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
        const regex = new RegExp(expression);

        return url.match(regex);
      },
      validateFile: (file, validExtensions, fileLabel) => {
        if (!file) throw new Error(`Arquivo(${fileLabel}) não informado`);

        let extension = file.name.match(/\.[0-9a-zA-Z]+$/i)[0];
        extension = extension && extension.toLowerCase();

        if (validExtensions && (validExtensions.indexOf(extension) === -1))
          throw new Error(`Extensão inválida do Arquivo(${fileLabel})`);
      },
      uploadToS3: ({ file, path, storageType }) => {
        const extension = file.name.match(/\.[0-9a-z]+$/i)[0];

        const filename = this.fileCore.removeAccents(file.name).concat(extension);

        return this.fileCore.signedUploadFile({
          path,
          filename,
          storageType,
          file,
        });
      },
    };

    this.appCore = {
      simpleApp: ({
        method,
        url,
        headers,
        data,
      }) => this.simpleAjax({
        url: `${this.portal.url.endPoint.app}${url}`,
        method,
        headers,
        data,
      }),

      updateCustomValue: ({
        moduleId,
        customValue,
        itemId,
        saveOnS3,
        s3Path,
        s3Props = [],
      } = {}) => new Promise((resolve, reject) => {
        this.appCore.simpleApp({
          method: 'POST',
          url: `/v1/session/app/${this.company.json.id}/config/update/customValue`,
          data: customValue,
          headers: {
            'module-id': moduleId ? encodeURIComponent(moduleId) : undefined,
            'item-id': itemId ? encodeURIComponent(itemId) : undefined,
            's3-save': saveOnS3,
            's3-path': s3Path ? encodeURIComponent(s3Path) : undefined,
            's3-props': encodeURIComponent(JSON.stringify(s3Props)),
          },
        })
          .then(res => resolve(res))
          .catch(err => reject(err));
      }),
    };

    this.proCore = {

      // checkEmail: (email) => this.simpleRouter({
      //   event: 'user/validateEmail',
      //   user: {
      //     id: this.company.json.id, email
      //   }
      // }),

      // createUser: email => this.simpleRouter({
      //   event: 'user/new',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //   },
      // }),

      // requestNewPassword: email => this.simpleRouter({
      //   event: 'user/requestNewPassword',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //   },
      // }),

      // loginByDirectScriptToken: hash => this.simpleRouter({
      //   event: 'directScript/authenticate',
      //   hash,
      // }),

      // completeUserRegister: (hash, email, name, date, password, phone) => this.simpleRouter({
      //   event: 'user/completeRegister',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //     nick: name,
      //     birth: date,
      //     password,
      //     createdHash: hash,
      //     phone
      //   }
      // }),

      // login: (email, password) => this.simpleRouter({
      //   event: 'general/login',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //     password
      //   }
      // }),

      // sessionValidate: (token) => this.simpleRouter({
      //   event: 'session/validate',
      //   user: {
      //     id: this.company.json.id,
      //     code: token
      //   }
      // }),

      // changePasswordByLogin: (email, passwordHash, password) => this.simpleRouter({
      //   event: 'user/changePasswordByLogin',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //     password,
      //     passwordHash
      //   },
      //   list: JSON.parse(JSON.stringify(this.user.selectedEntity))
      // }),

      // toggleCnpj: () => this.simpleRouter({
      //   event: 'cnpj/toggleEnable',
      //   user: {
      //     id: this.company.json.id,
      //     email: this.user.json.email,
      //     code: this.user.token
      //   },
      //   list: JSON.parse(JSON.stringify(this.user.selectedEntity)),
      // }),

      setActivity: (pointer, json, { sendNotification, userInfo } = {}) => new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          headers: {
            'Content-Type': 'application/json',
            code: this.user.token,
            pointer: encodeURIComponent(pointer),
            'send-notification': sendNotification,
            nick: _.get(userInfo, 'nick'),
            phone: _.get(userInfo, 'phone'),
            email: _.get(userInfo, 'email'),
          },
          url: `${this.portal.url.endPoint.activity}/v1/session/app/${this.company.json.id}/set`,
          data: JSON.stringify(json),
        })
          .always((res, statusText, xhr) => {
            const status = _.get(res, 'status') || _.get(xhr, 'status');

            if (status === 201) return resolve();

            reject(res);
          });
      }),

      // validatePasswordHash: (email, hash) => this.simpleRouter({
      //   event: 'user/validatePasswordHash',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //     passwordHash: hash,
      //   },
      // }),

      // validateCreatedHash: (email, hash) => this.simpleRouter({
      //   event: 'user/validateCreatedHash',
      //   user: {
      //     id: this.company.json.id,
      //     email,
      //     createdHash: hash,
      //   },
      // }),

      // nreq: (sqlId, connectorId) => new Promise((resolve, reject) => {
      //   if (sqlId && connectorId) {
      //     this.remoteSqlCore.executeSqlBypass(undefined, undefined, {
      //       companyId: undefined,
      //       token: undefined,
      //       connectorId,
      //       sqlId,
      //     }, res => {
      //       if (this.log) console.log(`RES - nreqExecute(${sqlId}) - `, res);
      //       if (!res || (res.status !== 200 && res.status !== '200')) return reject({ status: 401, error: res });
      //       return resolve(res);
      //     });
      //   } else {
      //     return resolve({ status: 200, rows: [] });
      //   }

      // }),

      updateFeedback: feedbackScore => new Promise((resolve, reject) => {
        this.authCore.updateUser({ feedbackScore })
          .then(res => {
            brain.setActivity('updateFeedback', { feedback: feedbackScore }, true);
            resolve(res);
          })
          .catch(reject);
      }),

      // sendEmail: (body, from, to, subject, replace, replyTo = []) => new Promise((resolve, reject) => {
      //   const html = `
      //   <!doctype html>
      //   <html lang="pt-br">
      //     <head>
      //       <meta charset="utf-8">
      //       <meta name="viewport" content="width=device-width, initial-scale=1">
      //     </head>
      //     <body>${body}</body>
      //   </html>`;

      //   $.ajax({
      //     type: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       code: this.user.token,
      //     },
      //     url: `${this.portal.url.endPoint.app}/v1/session/app/${this.company.json.id}/email/send`,
      //     data: JSON.stringify({
      //       html,
      //       from,
      //       to,
      //       subject,
      //       replace,
      //       replyTo
      //     })
      //   })
      //     .then(resolve)
      //     .fail(reject)
      // }),

      // removeCnpj: cnpj => this.simpleRouter({
      //   event: 'cnpj/remove',
      //   user: {
      //     id: this.company.json.id,
      //     code: this.user.token,
      //   },
      //   userEntity: cnpj,
      // }),

      /** @deprecated */
      changePasswordByDash: (password, newPassword) => this.simpleRouter({
        event: 'user/changePasswordByDash',
        user: {
          id: this.company.json.id,
          code: this.user.token,
          password: newPassword,
          oldPassword: password,
        },
      }),

      // searchCnpjAjax: (search, limit) => {
      //   if (!search) search = '0';
      //   if (limit) limit = limit.toString();
      //   else limit = '1';

      //   return new Promise((resolve, reject) => {
      //     if (this.log) console.log('START PROCORE SEARCHAJAX');
      //     this.router({
      //       event: 'cnpj/searchAjax',
      //       user: {
      //         id: this.company.json.id,
      //         code: this.user.token,
      //       },
      //       search,
      //       limit,
      //     })
      //       .then(res => {
      //         if (this.log) console.log(`RES - searchAjax - `, res);
      //         return resolve(res);
      //       })
      //       .catch(err => {
      //         if (this.log) console.log(`ERR - searchAjax - `, err);
      //         return reject(err);
      //       });
      //   });
      // },

    };

    this.router = arg => new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        url: `${this.portal.url.endPoint.core}/router`,
        data: JSON.stringify(arg),
      }).then(res => resolve(res))
        .fail(err => {
          brain.connectionError({ body: arg, stack: { data: err } }, false);
          return reject(err);
        });
    });

    this.simpleRouter = body => new Promise((resolve, reject) => {
      if (!body || !body.event) {
        return reject({
          status: '#ERRO_ROUTER_REQUEST',
        });
      }

      this.router(body).then(res => {
        if (this.log) console.log(`RES -> ${body.event} -> `, res);

        if (res.status === '#SESSION_NOTFOUND' || res.status === '#INVALID_TOKEN' || res.status === '#USER_TOKEN_NOTFOUND') return brain.sessionError();

        if (res && res.status === 0) return reject(res);

        if (res.status === 409 || res.status === '409') return reject(res);
        if (res.status === 400 || res.status === '400') return reject(res);

        if (res.status != 200 && res.status != 201 && res.status != '200' && res.status != '201' && res.status != 404 && res.status != '404') {
          return reject({
            status: 401,
            message: res.message,
          });
        }

        return resolve(res);
      })
        .catch(err => {
          if (this.log) console.log(`ERR -> ${body.event} -> `, res);
          return reject({
            status: 500,
            message: err,
          });
        });
    });

    // this.updateUser = body => new Promise((resolve, reject) => {
    //   $.ajax({
    //     type: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       code: this.user.token,
    //     },
    //     url: `${this.portal.url.endPoint.auth}/v1/session/app/${this.company.json.id}/user/update`,
    //     data: JSON.stringify(body)
    //   })
    //     .then(resolve)
    //     .fail(err => {
    //       if (err.status === 401) return brain.sessionError();
    //       reject(err)
    //     })
    // })

    this.downloadCsv = (content, outputName) => {
      try {
        const base64 = `data:application/csv;base64,${this.base64Encode(content)}`;
        return this.downloadFile(base64, `${outputName}.csv`);
      } catch (err) {
        console.error('utils downloadCsv - Error:', err);
        throw err;
      }
    };

    this.base64Encode = str =>
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      btoa(
        encodeURIComponent(str)
          .replace(
            /%([0-9A-F]{2})/g,
            (match, p1) => String.fromCharCode(`0x${p1}`),
          ),
      );
    this.downloadFile = (data, fileName) => {
      const aTag = document.createElement('a');
      aTag.download = fileName;
      aTag.target = '_blank';
      aTag.href = data;
      document.body.appendChild(aTag);
      aTag.click();
      setTimeout(() => {
        document.body.removeChild(aTag);
      }, 0);
    };

    this.copyText = text => {
      const inputTemp = document.createElement('input');
      inputTemp.value = text;
      document.body.appendChild(inputTemp);
      inputTemp.select();
      document.execCommand('copy');
      document.body.removeChild(inputTemp);
    };

    this.getFileExtension = filename => filename.split('.').reverse()[0].toLowerCase();

    this.forceDownloadFile = async (link, name, type) => {
      try {
        const isLink = typeof link === 'string' && link.startsWith('http');
        if (!isLink) {
          if (!link.startsWith('data:')) {
            const base64Link = `data:application/${type};charset=utf-8;base64,${link}`;
            return this.downloadFile(base64Link, name);
          }
          return this.downloadFile(link, name);
        }

        const downloadPage = await fetch(link);
        const blob = await downloadPage.blob();

        const url = (window.URL || window.webkitURL).createObjectURL(blob);

        return this.downloadFile(url, name);
      } catch (err) {
        console.error('Error downloadFile content', err);
        return this.downloadFile(link, name);
      }
    };

    /**
     * @param {string} id identificador dentro da configuração geral do módulo (util para módulos com multiplos scripts/itens diferentes, ex: marketing)
     * @param {string} moduleId se deseja buscar a configuração de outro módulo (que não está aberto)
     * @param {boolean} reloadJSON se é para recarregar as configurações do portal (util para saber se houve alterações no JSON, antes de salvar)
     * @return {object} customValue
     */
    this.getCustomValue = async ({
      id = '',
      moduleId = '',
      reloadJSON = false,
    } = {}) => {
      let config = brain.currentModule.item.customValue || _.get(brain.currentModule.module.customValue, id) || brain.currentModule.module.customValue || {};

      if (moduleId && moduleId !== brain.currentModule.module.id) {
        let appConfig = brain.company.json;

        if (reloadJSON) {
          const json = await brain.company.downloadJsonByDomain();

          appConfig = await brain.company.formatJson(json);
        }

        const moduleConfig = appConfig.module.find(i => i.id === moduleId);

        config = moduleConfig.customValue;
      }

      if (config.saveOnS3)
        return await this.getCustomValueFromS3(config);

      return config;
    };

    this.getCustomValueFromS3 = config => new Promise((resolve, reject) => {
      if (config.s3Link) {
        $.ajax({
          method: 'GET',
          url: config.s3Link,
          headers: {
            Pragma: 'no-cache',
            'Cache-Control': 'no-cache',
          },
        })
          .then(res => {
            if (res) {
              if (typeof res === 'string') res = JSON.parse(res);
              if (
                typeof res === 'object'
                && Object.keys(res).length > 0
              ) config = { ...config, ...res };
            }

            return resolve(config);
          })
          .fail(err => {
            console.error('err getConfig:', err);

            return resolve(config);
          });
      } else {
        return resolve(config);
      }
    });

    this.format = {

      objectToQueryString(data, invalidFields = []) {
        return Object.entries(data)
          .reduce((acc, [key, value]) => {
            if (invalidFields.includes(key)) return acc;

            if (typeof value === 'undefined') return acc;

            return [...acc, `${key}=${encodeURIComponent(value)}`];
          }, [])
          .join('&');
      },

      objectToString(obj) {
        if (typeof obj === 'string') return obj;

        try {
          return JSON.stringify(obj);
        } catch (err) {
          return obj;
        }
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      // currency: function (value, options) {
      //   return new Intl.NumberFormat('pt-BR', {
      //     style: 'currency',
      //     currency: 'BRL'
      //   }).format(value);
      // },

      // currencyToNfe: function (value, options) {
      //   let divisor = 0;
      //   if (!options) options = {
      //     minimumSignificantDigits: 7
      //   }
      //   if (!options.divisor) divisor = 1000;
      //   return new Intl.NumberFormat('pt-BR', options).format(value / divisor)
      // }
    };


    this.bankBillCore = {

      sendNoBearerEmail: ({
        app,
        bill,
      }) => new Promise((resolve, reject) => this.ajaxMicroservice({
        method: 'POST',
        uri: `/v1/session/app/${app}/sendNoBearerEmail`,
        microservice: 'bankbill',
        data: {
          bill,
        },
      }).then(response => resolve(response))
        .catch(error => reject(error))),
    };

    this.mobileCheck = () => {
      let check = false;
      (a => {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };

    this.getPlatform = () => {
      if (this.mobileCheck()) return 'mobile';
      return 'desktop';
    };

    this.getViewport = () => {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

      return `${vw}x${vh}`;
    };

    this.hasToAcceptNotifications = () => {
      if (!this.company.hasNotificationsSettings())
        return false;
      if (!this.user?.json?.notifications?.revisionDate)
        return true;

      const dates = Object.keys(this.company.json.notifications)
        .map(item => this.company.json.notifications[item].configurationDate);
      const latestCompanyDate = this.getLatestDate(dates);

      const isCompanyDateHigherThanUserDate = !(this.getLatestDate([latestCompanyDate,
        this.user.json.notifications.revisionDate]) === this.user.json.notifications.revisionDate);

      return isCompanyDateHigherThanUserDate;
    };

    this.getLatestDate = dates => {
      const getTimestamp = str => new Date(...str.split('/').reverse()).getTime();

      const sortedDates = dates.sort((a, b) => getTimestamp(a) - getTimestamp(b));
      return sortedDates[sortedDates.length - 1];
    };
  }
}
